// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Ghost,
    Gift,
    GitBranch,
    GitBranchMinus,
    GitBranchPlus,
    GitCommitHorizontal,
    GitCommitVertical,
    GitCompare,
    GitCompareArrows,
    GitFork,
    GitGraph,
    GitMerge,
    GitMergeConflict,
    GitPullRequest,
    GitPullRequestArrow,
    GitPullRequestClosed,
    GitPullRequestCreate,
    GitPullRequestCreateArrow,
    GitPullRequestDraft,
    GlassWater,
    Glasses,
    Globe,
    GlobeCheck,
    GlobeLock,
    GlobeOff,
    GlobeX,
    Goal,
    Gpu,
    GraduationCap,
    Grape,
    Grid2x2,
    Grid2x2Check,
    Grid2x2Plus,
    Grid2x2X,
    Grid3x2,
    Grid3x3,
    Grip,
    GripHorizontal,
    GripVertical,
    Group,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "ghost" through "group", inclusive. */
const shard: Record<string, LucideIcon> = {
    ghost: Ghost,
    gift: Gift,
    "git-branch": GitBranch,
    "git-branch-minus": GitBranchMinus,
    "git-branch-plus": GitBranchPlus,
    "git-commit-horizontal": GitCommitHorizontal,
    "git-commit-vertical": GitCommitVertical,
    "git-compare": GitCompare,
    "git-compare-arrows": GitCompareArrows,
    "git-fork": GitFork,
    "git-graph": GitGraph,
    "git-merge": GitMerge,
    "git-merge-conflict": GitMergeConflict,
    "git-pull-request": GitPullRequest,
    "git-pull-request-arrow": GitPullRequestArrow,
    "git-pull-request-closed": GitPullRequestClosed,
    "git-pull-request-create": GitPullRequestCreate,
    "git-pull-request-create-arrow": GitPullRequestCreateArrow,
    "git-pull-request-draft": GitPullRequestDraft,
    "glass-water": GlassWater,
    glasses: Glasses,
    globe: Globe,
    "globe-check": GlobeCheck,
    "globe-lock": GlobeLock,
    "globe-off": GlobeOff,
    "globe-x": GlobeX,
    goal: Goal,
    gpu: Gpu,
    "graduation-cap": GraduationCap,
    grape: Grape,
    "grid-2x2": Grid2x2,
    "grid-2x2-check": Grid2x2Check,
    "grid-2x2-plus": Grid2x2Plus,
    "grid-2x2-x": Grid2x2X,
    "grid-3x2": Grid3x2,
    "grid-3x3": Grid3x3,
    grip: Grip,
    "grip-horizontal": GripHorizontal,
    "grip-vertical": GripVertical,
    group: Group,
};

export default shard;
